








































































































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Transporteur} from '@/models';

import storeTransporteur from '@/stores/modules/transporteur';

import InputPhone from '@/components/Input/Phone.vue';

@Component({
	components: {
		InputPhone,
	}
})
export default class CrudTransporteurEdit extends AbstractEditVue<Transporteur> {
	public constructor() {
		super(
			storeTransporteur,
			'Transporteur modifié',
			'Transporteur créé',
		);
	}
}
